unit unit_AenderungLieferanschrift;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, DB,
  WEBLib.Grids;

type
  TAenderungLieferanschrift = class(TForm)
    xdsLaender: TXDataWebDataSet;
    xdsLaenderLaenderkuerzel: TStringField;
    xdsLaenderLand: TStringField;
    xdsLaenderEULand: TIntegerField;
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenGruppeKunden: TBooleanField;
    xdsKundendatenGruppeLieferanten: TBooleanField;
    xdsKundendatenGruppeSonstige: TBooleanField;
    xdsKundendatenGruppeNichtkunden: TBooleanField;
    xdsKundendatenKontaktgruppe: TStringField;
    xdsKundendatenNachname: TStringField;
    xdsKundendatenVorname: TStringField;
    xdsKundendatenAdresszeile2: TStringField;
    xdsKundendatenAdresszeile3: TStringField;
    xdsKundendatenStrasse: TStringField;
    xdsKundendatenPostleitzahl: TStringField;
    xdsKundendatenOrt: TStringField;
    xdsKundendatenLaenderkuerzel: TStringField;
    xdsKundendatenLand: TStringField;
    xdsKundendatenLaenderkennzeichen: TBooleanField;
    xdsKundendatenAdressanrede: TStringField;
    xdsKundendatenBriefanrede1: TStringField;
    xdsKundendatenAdresseBild: TStringField;
    xdsKundendatenLieferanschrift: TStringField;
    xdsKundendatenTelefonNummer: TStringField;
    xdsKundendatenTelefaxNummer: TStringField;
    xdsKundendatenMobilTelefon: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenInternet: TStringField;
    xdsKundendatenUmsatzsteuerID: TStringField;
    xdsKundendatenUmsatzsteuerausweis: TBooleanField;
    xdsKundendatenZahlungsbedingung: TIntegerField;
    xdsKundendatenTransportbedingung: TStringField;
    xdsKundendatenKeinNewsletter: TBooleanField;
    xdsKundendatenTelefonAlternativ: TStringField;
    xdsKundendatenTitel: TStringField;
    xdsKundendatenKundenklasseFarbe: TIntegerField;
    xdsKundendatenRechnungEmail: TStringField;
    xdsKundendatenLoginPW: TStringField;
    xdsKundendatenBesteuerungKey: TIntegerField;
    xdsKundendatenAuftraegeJahr: TFloatField;
    xdsKundendatenAuftraegeVorjahr: TFloatField;
    xdsKundendatenLieferadresseID: TIntegerField;
    xdsKundendatenUSTIDgeprueft: TDateTimeField;
    xdsKundendatenKontaktverbund: TStringField;
    xdsKundendatenHinweis: TStringField;
    xdsKundendatenLatitude: TFloatField;
    xdsKundendatenLongitude: TFloatField;
    xdsKundendatenkmLuftlinie: TFloatField;
    xdsKundendatenGoogleID: TStringField;
    xdsKundendatenGoogleUpdatedUTC: TDateTimeField;
    xdsKundendatenBundesland: TStringField;
    xdsKundendatenRegion: TStringField;
    xdsKundendatenMandatsreferenz: TStringField;
    xdsKundendatenMandatsreferenzVom: TDateTimeField;
    xdsKundendatenLastschriftArt: TStringField;
    xdsKundendatenMahnsperre: TBooleanField;
    xdsKundendatenSuchbegriff: TStringField;
    xdsKundendatenLieferanschriftDaten: TStringField;
    xdsKundendatenExportKasse: TBooleanField;
    xdsKundendatenLoeschvormerkungDatum: TDateTimeField;
    xdsKundendatenLoeschvormerkungGrund: TStringField;
    xdsKundendatenPseudonymisiert: TStringField;
    xdsKundendatenLoginAktiv: TIntegerField;
    xdsKundendatenSonstigeDaten: TStringField;
    xdsProtokoll: TXDataWebDataSet;
    xdsProtokollID: TIntegerField;
    xdsProtokollDatum: TDateTimeField;
    xdsProtokollKundennummer: TStringField;
    xdsProtokollNotiz: TStringField;
    xdsProtokollPruefungErforderlich: TBooleanField;
    xdsProtokollPruefungErledigt: TDateTimeField;
    xdsProtokollPruefungErledigtDurch: TStringField;
    xdsProtokollBemerkung: TStringField;
    TC: TTableControl;
    procedure WebFormShow(Sender: TObject);
    procedure xdsProtokollAfterOpen(DataSet: TDataSet);
    procedure xdsLaenderAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterPost(DataSet: TDataSet);
    procedure xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    btnAbsenden:TButton;
    buttonzurueck:TButton;
    buttonloeschen:TButton;
    procedure btnAbsendenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
    procedure buttonloeschenclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  AenderungLieferanschrift: TAenderungLieferanschrift;
  edtAdressanrede:TComboBox;
  edtNachname:TEdit;
  edtVorname:TEdit;
  edtAdresszeile2:TEdit;
  edtAdresszeile3:TEdit;
  edtStrasse:TEdit;
  edtPostleitzahl:TEdit;
  edtOrt:TEdit;
  edtLand:TComboBox;
  edtTelefon1:TEdit;
  edtTitel:TEdit;

implementation
  uses unit1, unit2;
{$R *.dfm}


procedure TAenderungLieferanschrift.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TAenderungLieferanschrift.btnAbsendenclick(Sender: TObject);
begin
    if edtNachname.Text='' then
    begin
      showmessage('Sie müssen einen Nachnamen eingeben');
      exit;
    end;
    if edtStrasse.Text='' then
    begin
      showmessage('Sie müssen die Strasse eingeben');
      exit;
    end;
    if edtPostleitzahl.Text='' then
    begin
      showmessage('Sie müssen die Postleitzahl eingeben');
      exit;
    end;
    if edtOrt.Text='' then
    begin
      showmessage('Sie müssen den Ort eingeben');
      exit;
    end;
    if edtLand.Text='' then
    begin
      showmessage('Sie müssen das Land auswählen');
      exit;
    end;
  xdsLaender.Locate('Land',edtLand.Text,[]);
  form1.LAR.Land:=xdsLaenderLand.AsString;
  form1.LAR.Laenderkuerzel:=xdsLaenderLaenderkuerzel.AsString;

  form1.LAR.Adressanrede:=edtAdressanrede.Text;
  form1.LAR.Nachname:=edtNachname.Text;
  form1.LAR.Vorname:=edtVorname.Text;
  form1.LAR.Adresszeile2:=edtAdresszeile2.Text;
  form1.LAR.Adresszeile3:=edtAdresszeile3.Text;
  form1.LAR.Strasse:=edtStrasse.Text;
  form1.LAR.Postleitzahl:=edtPostleitzahl.Text;
  form1.LAR.Ort:=edtOrt.Text;
  form1.LAR.Titel:=edtTitel.Text;
  form1.LAR.Telefon:=edtTelefon1.Text;

  form1.LARLISTfromRECORD;
  form1.LARadresseberechnen;
  xdsKundendaten.Edit;
  xdsKundendatenLieferanschrift.AsString:=form1.LAR.Adressebild;
  xdsKundendatenLieferanschriftDaten.AsString:=Form1.LARLIST.Text;

  xdsProtokoll.Append;
  xdsProtokollDatum.AsDateTime:=date+time;
  xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
  xdsProtokollPruefungErforderlich.AsBoolean:=true;
  xdsProtokollNotiz.AsString:='Lieferanschrift geändert, Prüfung vornehmen '+InternetIpAdresse;
  xdsProtokoll.Post;
  xdsProtokoll.ApplyUpdates;

  xdsKundendaten.Post;
end;

procedure TAenderungLieferanschrift.buttonLoeschenclick(Sender: TObject);
begin
  xdsKundendaten.Edit;
  xdsKundendatenLieferanschrift.AsString:='';
  xdsKundendatenLieferanschriftDaten.AsString:='';
  xdsProtokoll.Append;
  xdsProtokollDatum.AsDateTime:=date+time;
  xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
  xdsProtokollPruefungErforderlich.AsBoolean:=true;
  xdsProtokollNotiz.AsString:='Lieferanschrift gelöscht, Prüfung vornehmen '+InternetIpAdresse;
  xdsProtokoll.Post;
  xdsProtokoll.ApplyUpdates;
  xdsKundendaten.Post;
end;

procedure TAenderungLieferanschrift.WebFormShow(Sender: TObject);
begin
  xdsProtokoll.Load;
end;

procedure TAenderungLieferanschrift.xdsKundendatenAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    close;
  end;

end;

procedure TAenderungLieferanschrift.xdsKundendatenAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  i:integer;
begin
  if xdskundendatenlieferanschriftdaten.AsString<>'' then
  begin
    form1.LARLIST.Text:=xdsKundendatenLieferanschriftDaten.AsString;
    form1.LARLISTtoRECORD;
  end
  else
  begin
    form1.LARleeren;
  end;
  TC.ColCount:=1;
  TC.RowCount:=15;

  TC.Cells[0,0]:='<h4>Änderung Lieferanschrift';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left m-1';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  myelement:=TC.cellelements[0,i];
  btnAbsenden:=TButton.Create(self);
  btnAbsenden.ElementClassName:='btn btn-info text-left m-1';
  btnAbsenden.HeightStyle:=ssauto;
  btnAbsenden.WidthStyle:=ssauto;
  btnAbsenden.tag:=0;
  btnAbsenden.Caption:='speichern';
  btnAbsenden.OnClick:=@btnAbsendenClick;
  btnAbsenden.ParentElement:=myelement;

  buttonloeschen:=TButton.Create(self);
  buttonloeschen.ElementClassName:='btn btn-info text-left m-1';
  buttonloeschen.HeightStyle:=ssauto;
  buttonloeschen.WidthStyle:=ssauto;
  buttonloeschen.tag:=0;
  buttonloeschen.Caption:='löschen';
  buttonloeschen.OnClick:=@buttonloeschenclick;
  buttonloeschen.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Adressanrede<br>';
  myelement:=TC.CellElements[0,i];
  edtAdressanrede:=TComboBox.Create(self);
  edtAdressanrede.ElementClassName:='form-control';
  edtAdressanrede.Width:=200;
  edtAdressanrede.HeightStyle:=ssAuto;

  edtAdressanrede.ItemIndex:=-1;
  edtAdressanrede.ParentElement:=myelement;
  edtAdressanrede.Items.Clear;
  edtAdressanrede.Items.Add('Firma');
  edtAdressanrede.Items.Add('Herrn');
  edtAdressanrede.Items.Add('Frau');
  edtadressanrede.Text:=form1.LAR.Adressanrede;

  inc(i);
  TC.Cells[0,i]:='Titel<br>';
  myelement:=TC.CellElements[0,i];
  edtTitel:=TEdit.Create(self);
  edtTitel.ElementClassName:='form-control';
  edtTitel.Width:=400;
  edtTitel.HeightStyle:=ssAuto;
  edtTitel.TextHint:='Titel';
  edtTitel.MaxLength:=20;
  edtTitel.Text:=form1.LAR.Titel;
  edtTitel.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Nachname/Firma<br>';
  myelement:=TC.CellElements[0,i];
  edtNachname:=TEdit.Create(self);
  edtNachname.ElementClassName:='form-control';
  edtNachname.Width:=400;
  edtNachname.HeightStyle:=ssAuto;
  edtNachname.TextHint:='Nachname/Firma';
  edtNachname.MaxLength:=40;
  edtNachname.Text:=form1.LAR.Nachname;
  edtNachname.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Vorname<br>';
  myelement:=TC.CellElements[0,i];
  edtVorname:=TEdit.Create(self);
  edtVorname.ElementClassName:='form-control';
  edtVorname.Width:=400;
  edtVorname.HeightStyle:=ssAuto;
  edtVorname.TextHint:='Vorname(wenn keine eingetragene Firma)';
  edtVorname.MaxLength:=40;
  edtVorname.Text:=form1.LAR.Vorname;
  edtVorname.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Adresszeile2<br>';
  myelement:=TC.CellElements[0,i];
  edtAdresszeile2:=TEdit.Create(self);
  edtAdresszeile2.ElementClassName:='form-control';
  edtAdresszeile2.Width:=400;
  edtAdresszeile2.HeightStyle:=ssAuto;
  edtAdresszeile2.TextHint:='Adresszeile2(wenn mehr Platz benötigt)';
  edtAdresszeile2.MaxLength:=40;
  edtadresszeile2.Text:=form1.LAR.Adresszeile2;
  edtAdresszeile2.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Adresszeile3<br>';
  myelement:=TC.CellElements[0,i];
  edtAdresszeile3:=TEdit.Create(self);
  edtAdresszeile3.ElementClassName:='form-control';
  edtAdresszeile3.Width:=400;
  edtAdresszeile3.HeightStyle:=ssAuto;
  edtAdresszeile3.TextHint:='Adresszeile3(wenn mehr Platz benötigt)';
  edtAdresszeile3.MaxLength:=40;
  edtadresszeile3.Text:=form1.LAR.Adresszeile3;
  edtAdresszeile3.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Strasse<br>';
  myelement:=TC.CellElements[0,i];
  edtStrasse:=TEdit.Create(self);
  edtStrasse.ElementClassName:='form-control';
  edtStrasse.Width:=400;
  edtStrasse.HeightStyle:=ssAuto;
  edtStrasse.TextHint:='Strasse und Hausnummer';
  edtStrasse.MaxLength:=40;
  edtstrasse.Text:=form1.LAR.Strasse;
  edtStrasse.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Postleitzahl<br>';
  myelement:=TC.CellElements[0,i];
  edtPostleitzahl:=TEdit.Create(self);
  edtPostleitzahl.ElementClassName:='form-control';
  edtPostleitzahl.Width:=100;
  edtPostleitzahl.HeightStyle:=ssAuto;
  edtPostleitzahl.TextHint:='Postleitzahl';
  edtPostleitzahl.MaxLength:=10;
  edtPostleitzahl.Text:=form1.LAR.Postleitzahl;
  edtPostleitzahl.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Ort<br>';
  myelement:=TC.CellElements[0,i];
  edtOrt:=TEdit.Create(self);
  edtOrt.ElementClassName:='form-control';
  edtOrt.Width:=400;
  edtOrt.HeightStyle:=ssAuto;
  edtOrt.TextHint:='Ort';
  edtOrt.MaxLength:=40;
  edtOrt.Text:=form1.LAR.Ort;
  edtOrt.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Land<br>';
  myelement:=TC.CellElements[0,i];
  edtLand:=TComboBox.Create(self);
  edtLand.ElementClassName:='form-control';
  edtLand.Width:=400;
  edtLand.HeightStyle:=ssAuto;

  edtLand.ItemIndex:=-1;

  edtLand.ParentElement:=myelement;
  edtland.Items.Clear;
  xdsLaender.First;
  while not xdslaender.eof do
  begin
    edtland.Items.Add(xdsLaenderLand.asstring);
    xdslaender.Next;
  end;
  edtLand.Text:=form1.LAR.Land;

  inc(i);
  TC.Cells[0,i]:='Telefon/Bemerkung<br>';
  myelement:=TC.CellElements[0,i];
  edtTelefon1:=TEdit.Create(self);
  edtTelefon1.ElementClassName:='form-control';
  edtTelefon1.Width:=300;
  edtTelefon1.HeightStyle:=ssAuto;
  edtTelefon1.TextHint:='Telefon/Bemerkung';
  edtTelefon1.MaxLength:=255;
  edtTelefon1.Text:=form1.LAR.Telefon;
  edtTelefon1.ParentElement:=myelement;

  buttonzurueck.setfocus;
  edtAdressanrede.SetFocus;
  TC.Cells[0,0]:='<h4>Änderung Lieferanschrift';

end;

procedure TAenderungLieferanschrift.xdsKundendatenAfterPost(DataSet: TDataSet);
begin
xdsKundendaten.ApplyUpdates;
end;

procedure TAenderungLieferanschrift.xdsLaenderAfterOpen(DataSet: TDataSet);
begin
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKundendaten.Load;
end;

procedure TAenderungLieferanschrift.xdsProtokollAfterOpen(DataSet: TDataSet);
begin
  xdsLaender.Load;
end;

procedure TAenderungLieferanschrift.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsLaender := TXDataWebDataSet.Create(Self);
  xdsLaenderLaenderkuerzel := TStringField.Create(Self);
  xdsLaenderLand := TStringField.Create(Self);
  xdsLaenderEULand := TIntegerField.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenGruppeKunden := TBooleanField.Create(Self);
  xdsKundendatenGruppeLieferanten := TBooleanField.Create(Self);
  xdsKundendatenGruppeSonstige := TBooleanField.Create(Self);
  xdsKundendatenGruppeNichtkunden := TBooleanField.Create(Self);
  xdsKundendatenKontaktgruppe := TStringField.Create(Self);
  xdsKundendatenNachname := TStringField.Create(Self);
  xdsKundendatenVorname := TStringField.Create(Self);
  xdsKundendatenAdresszeile2 := TStringField.Create(Self);
  xdsKundendatenAdresszeile3 := TStringField.Create(Self);
  xdsKundendatenStrasse := TStringField.Create(Self);
  xdsKundendatenPostleitzahl := TStringField.Create(Self);
  xdsKundendatenOrt := TStringField.Create(Self);
  xdsKundendatenLaenderkuerzel := TStringField.Create(Self);
  xdsKundendatenLand := TStringField.Create(Self);
  xdsKundendatenLaenderkennzeichen := TBooleanField.Create(Self);
  xdsKundendatenAdressanrede := TStringField.Create(Self);
  xdsKundendatenBriefanrede1 := TStringField.Create(Self);
  xdsKundendatenAdresseBild := TStringField.Create(Self);
  xdsKundendatenLieferanschrift := TStringField.Create(Self);
  xdsKundendatenTelefonNummer := TStringField.Create(Self);
  xdsKundendatenTelefaxNummer := TStringField.Create(Self);
  xdsKundendatenMobilTelefon := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenInternet := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerID := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsKundendatenZahlungsbedingung := TIntegerField.Create(Self);
  xdsKundendatenTransportbedingung := TStringField.Create(Self);
  xdsKundendatenKeinNewsletter := TBooleanField.Create(Self);
  xdsKundendatenTelefonAlternativ := TStringField.Create(Self);
  xdsKundendatenTitel := TStringField.Create(Self);
  xdsKundendatenKundenklasseFarbe := TIntegerField.Create(Self);
  xdsKundendatenRechnungEmail := TStringField.Create(Self);
  xdsKundendatenLoginPW := TStringField.Create(Self);
  xdsKundendatenBesteuerungKey := TIntegerField.Create(Self);
  xdsKundendatenAuftraegeJahr := TFloatField.Create(Self);
  xdsKundendatenAuftraegeVorjahr := TFloatField.Create(Self);
  xdsKundendatenLieferadresseID := TIntegerField.Create(Self);
  xdsKundendatenUSTIDgeprueft := TDateTimeField.Create(Self);
  xdsKundendatenKontaktverbund := TStringField.Create(Self);
  xdsKundendatenHinweis := TStringField.Create(Self);
  xdsKundendatenLatitude := TFloatField.Create(Self);
  xdsKundendatenLongitude := TFloatField.Create(Self);
  xdsKundendatenkmLuftlinie := TFloatField.Create(Self);
  xdsKundendatenGoogleID := TStringField.Create(Self);
  xdsKundendatenGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsKundendatenBundesland := TStringField.Create(Self);
  xdsKundendatenRegion := TStringField.Create(Self);
  xdsKundendatenMandatsreferenz := TStringField.Create(Self);
  xdsKundendatenMandatsreferenzVom := TDateTimeField.Create(Self);
  xdsKundendatenLastschriftArt := TStringField.Create(Self);
  xdsKundendatenMahnsperre := TBooleanField.Create(Self);
  xdsKundendatenSuchbegriff := TStringField.Create(Self);
  xdsKundendatenLieferanschriftDaten := TStringField.Create(Self);
  xdsKundendatenExportKasse := TBooleanField.Create(Self);
  xdsKundendatenLoeschvormerkungDatum := TDateTimeField.Create(Self);
  xdsKundendatenLoeschvormerkungGrund := TStringField.Create(Self);
  xdsKundendatenPseudonymisiert := TStringField.Create(Self);
  xdsKundendatenLoginAktiv := TIntegerField.Create(Self);
  xdsKundendatenSonstigeDaten := TStringField.Create(Self);
  xdsProtokoll := TXDataWebDataSet.Create(Self);
  xdsProtokollID := TIntegerField.Create(Self);
  xdsProtokollDatum := TDateTimeField.Create(Self);
  xdsProtokollKundennummer := TStringField.Create(Self);
  xdsProtokollNotiz := TStringField.Create(Self);
  xdsProtokollPruefungErforderlich := TBooleanField.Create(Self);
  xdsProtokollPruefungErledigt := TDateTimeField.Create(Self);
  xdsProtokollPruefungErledigtDurch := TStringField.Create(Self);
  xdsProtokollBemerkung := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsLaender.BeforeLoadDFMValues;
  xdsLaenderLaenderkuerzel.BeforeLoadDFMValues;
  xdsLaenderLand.BeforeLoadDFMValues;
  xdsLaenderEULand.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenGruppeKunden.BeforeLoadDFMValues;
  xdsKundendatenGruppeLieferanten.BeforeLoadDFMValues;
  xdsKundendatenGruppeSonstige.BeforeLoadDFMValues;
  xdsKundendatenGruppeNichtkunden.BeforeLoadDFMValues;
  xdsKundendatenKontaktgruppe.BeforeLoadDFMValues;
  xdsKundendatenNachname.BeforeLoadDFMValues;
  xdsKundendatenVorname.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile2.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile3.BeforeLoadDFMValues;
  xdsKundendatenStrasse.BeforeLoadDFMValues;
  xdsKundendatenPostleitzahl.BeforeLoadDFMValues;
  xdsKundendatenOrt.BeforeLoadDFMValues;
  xdsKundendatenLaenderkuerzel.BeforeLoadDFMValues;
  xdsKundendatenLand.BeforeLoadDFMValues;
  xdsKundendatenLaenderkennzeichen.BeforeLoadDFMValues;
  xdsKundendatenAdressanrede.BeforeLoadDFMValues;
  xdsKundendatenBriefanrede1.BeforeLoadDFMValues;
  xdsKundendatenAdresseBild.BeforeLoadDFMValues;
  xdsKundendatenLieferanschrift.BeforeLoadDFMValues;
  xdsKundendatenTelefonNummer.BeforeLoadDFMValues;
  xdsKundendatenTelefaxNummer.BeforeLoadDFMValues;
  xdsKundendatenMobilTelefon.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenInternet.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerID.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsKundendatenZahlungsbedingung.BeforeLoadDFMValues;
  xdsKundendatenTransportbedingung.BeforeLoadDFMValues;
  xdsKundendatenKeinNewsletter.BeforeLoadDFMValues;
  xdsKundendatenTelefonAlternativ.BeforeLoadDFMValues;
  xdsKundendatenTitel.BeforeLoadDFMValues;
  xdsKundendatenKundenklasseFarbe.BeforeLoadDFMValues;
  xdsKundendatenRechnungEmail.BeforeLoadDFMValues;
  xdsKundendatenLoginPW.BeforeLoadDFMValues;
  xdsKundendatenBesteuerungKey.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeJahr.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeVorjahr.BeforeLoadDFMValues;
  xdsKundendatenLieferadresseID.BeforeLoadDFMValues;
  xdsKundendatenUSTIDgeprueft.BeforeLoadDFMValues;
  xdsKundendatenKontaktverbund.BeforeLoadDFMValues;
  xdsKundendatenHinweis.BeforeLoadDFMValues;
  xdsKundendatenLatitude.BeforeLoadDFMValues;
  xdsKundendatenLongitude.BeforeLoadDFMValues;
  xdsKundendatenkmLuftlinie.BeforeLoadDFMValues;
  xdsKundendatenGoogleID.BeforeLoadDFMValues;
  xdsKundendatenGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsKundendatenBundesland.BeforeLoadDFMValues;
  xdsKundendatenRegion.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenz.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenzVom.BeforeLoadDFMValues;
  xdsKundendatenLastschriftArt.BeforeLoadDFMValues;
  xdsKundendatenMahnsperre.BeforeLoadDFMValues;
  xdsKundendatenSuchbegriff.BeforeLoadDFMValues;
  xdsKundendatenLieferanschriftDaten.BeforeLoadDFMValues;
  xdsKundendatenExportKasse.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungDatum.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungGrund.BeforeLoadDFMValues;
  xdsKundendatenPseudonymisiert.BeforeLoadDFMValues;
  xdsKundendatenLoginAktiv.BeforeLoadDFMValues;
  xdsKundendatenSonstigeDaten.BeforeLoadDFMValues;
  xdsProtokoll.BeforeLoadDFMValues;
  xdsProtokollID.BeforeLoadDFMValues;
  xdsProtokollDatum.BeforeLoadDFMValues;
  xdsProtokollKundennummer.BeforeLoadDFMValues;
  xdsProtokollNotiz.BeforeLoadDFMValues;
  xdsProtokollPruefungErforderlich.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigt.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigtDurch.BeforeLoadDFMValues;
  xdsProtokollBemerkung.BeforeLoadDFMValues;
  try
    Name := 'AenderungLieferanschrift';
    Width := 148;
    Height := 293;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 148;
    TC.Height := 257;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsLaender.SetParentComponent(Self);
    xdsLaender.Name := 'xdsLaender';
    xdsLaender.AfterOpen := xdsLaenderAfterOpen;
    xdsLaender.EntitySetName := 'Laender';
    xdsLaender.Connection := DM2.XDataWebConnection1;
    xdsLaender.QueryString := '$orderby=Land';
    xdsLaender.Left := 48;
    xdsLaender.Top := 40;
    xdsLaenderLaenderkuerzel.SetParentComponent(xdsLaender);
    xdsLaenderLaenderkuerzel.Name := 'xdsLaenderLaenderkuerzel';
    xdsLaenderLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsLaenderLaenderkuerzel.Required := True;
    xdsLaenderLaenderkuerzel.Size := 5;
    xdsLaenderLand.SetParentComponent(xdsLaender);
    xdsLaenderLand.Name := 'xdsLaenderLand';
    xdsLaenderLand.FieldName := 'Land';
    xdsLaenderEULand.SetParentComponent(xdsLaender);
    xdsLaenderEULand.Name := 'xdsLaenderEULand';
    xdsLaenderEULand.FieldName := 'EULand';
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterApplyUpdates := xdsKundendatenAfterApplyUpdates;
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.AfterPost := xdsKundendatenAfterPost;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 40;
    xdsKundendaten.Top := 104;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenGruppeKunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeKunden.Name := 'xdsKundendatenGruppeKunden';
    xdsKundendatenGruppeKunden.FieldName := 'GruppeKunden';
    xdsKundendatenGruppeLieferanten.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeLieferanten.Name := 'xdsKundendatenGruppeLieferanten';
    xdsKundendatenGruppeLieferanten.FieldName := 'GruppeLieferanten';
    xdsKundendatenGruppeSonstige.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeSonstige.Name := 'xdsKundendatenGruppeSonstige';
    xdsKundendatenGruppeSonstige.FieldName := 'GruppeSonstige';
    xdsKundendatenGruppeNichtkunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeNichtkunden.Name := 'xdsKundendatenGruppeNichtkunden';
    xdsKundendatenGruppeNichtkunden.FieldName := 'GruppeNichtkunden';
    xdsKundendatenKontaktgruppe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktgruppe.Name := 'xdsKundendatenKontaktgruppe';
    xdsKundendatenKontaktgruppe.FieldName := 'Kontaktgruppe';
    xdsKundendatenKontaktgruppe.Size := 50;
    xdsKundendatenNachname.SetParentComponent(xdsKundendaten);
    xdsKundendatenNachname.Name := 'xdsKundendatenNachname';
    xdsKundendatenNachname.FieldName := 'Nachname';
    xdsKundendatenNachname.Size := 40;
    xdsKundendatenVorname.SetParentComponent(xdsKundendaten);
    xdsKundendatenVorname.Name := 'xdsKundendatenVorname';
    xdsKundendatenVorname.FieldName := 'Vorname';
    xdsKundendatenVorname.Size := 40;
    xdsKundendatenAdresszeile2.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile2.Name := 'xdsKundendatenAdresszeile2';
    xdsKundendatenAdresszeile2.FieldName := 'Adresszeile2';
    xdsKundendatenAdresszeile2.Size := 40;
    xdsKundendatenAdresszeile3.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile3.Name := 'xdsKundendatenAdresszeile3';
    xdsKundendatenAdresszeile3.FieldName := 'Adresszeile3';
    xdsKundendatenAdresszeile3.Size := 40;
    xdsKundendatenStrasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenStrasse.Name := 'xdsKundendatenStrasse';
    xdsKundendatenStrasse.FieldName := 'Strasse';
    xdsKundendatenStrasse.Size := 40;
    xdsKundendatenPostleitzahl.SetParentComponent(xdsKundendaten);
    xdsKundendatenPostleitzahl.Name := 'xdsKundendatenPostleitzahl';
    xdsKundendatenPostleitzahl.FieldName := 'Postleitzahl';
    xdsKundendatenPostleitzahl.Size := 6;
    xdsKundendatenOrt.SetParentComponent(xdsKundendaten);
    xdsKundendatenOrt.Name := 'xdsKundendatenOrt';
    xdsKundendatenOrt.FieldName := 'Ort';
    xdsKundendatenOrt.Size := 40;
    xdsKundendatenLaenderkuerzel.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkuerzel.Name := 'xdsKundendatenLaenderkuerzel';
    xdsKundendatenLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsKundendatenLaenderkuerzel.Size := 5;
    xdsKundendatenLand.SetParentComponent(xdsKundendaten);
    xdsKundendatenLand.Name := 'xdsKundendatenLand';
    xdsKundendatenLand.FieldName := 'Land';
    xdsKundendatenLand.Size := 40;
    xdsKundendatenLaenderkennzeichen.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkennzeichen.Name := 'xdsKundendatenLaenderkennzeichen';
    xdsKundendatenLaenderkennzeichen.FieldName := 'Laenderkennzeichen';
    xdsKundendatenAdressanrede.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdressanrede.Name := 'xdsKundendatenAdressanrede';
    xdsKundendatenAdressanrede.FieldName := 'Adressanrede';
    xdsKundendatenAdressanrede.Size := 15;
    xdsKundendatenBriefanrede1.SetParentComponent(xdsKundendaten);
    xdsKundendatenBriefanrede1.Name := 'xdsKundendatenBriefanrede1';
    xdsKundendatenBriefanrede1.FieldName := 'Briefanrede1';
    xdsKundendatenBriefanrede1.Size := 255;
    xdsKundendatenAdresseBild.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresseBild.Name := 'xdsKundendatenAdresseBild';
    xdsKundendatenAdresseBild.FieldName := 'AdresseBild';
    xdsKundendatenAdresseBild.Size := 255;
    xdsKundendatenLieferanschrift.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschrift.Name := 'xdsKundendatenLieferanschrift';
    xdsKundendatenLieferanschrift.FieldName := 'Lieferanschrift';
    xdsKundendatenLieferanschrift.Size := 255;
    xdsKundendatenTelefonNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonNummer.Name := 'xdsKundendatenTelefonNummer';
    xdsKundendatenTelefonNummer.FieldName := 'TelefonNummer';
    xdsKundendatenTelefonNummer.Size := 25;
    xdsKundendatenTelefaxNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefaxNummer.Name := 'xdsKundendatenTelefaxNummer';
    xdsKundendatenTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsKundendatenTelefaxNummer.Size := 25;
    xdsKundendatenMobilTelefon.SetParentComponent(xdsKundendaten);
    xdsKundendatenMobilTelefon.Name := 'xdsKundendatenMobilTelefon';
    xdsKundendatenMobilTelefon.FieldName := 'MobilTelefon';
    xdsKundendatenMobilTelefon.Size := 25;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenInternet.SetParentComponent(xdsKundendaten);
    xdsKundendatenInternet.Name := 'xdsKundendatenInternet';
    xdsKundendatenInternet.FieldName := 'Internet';
    xdsKundendatenInternet.Size := 50;
    xdsKundendatenUmsatzsteuerID.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerID.Name := 'xdsKundendatenUmsatzsteuerID';
    xdsKundendatenUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsKundendatenUmsatzsteuerausweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerausweis.Name := 'xdsKundendatenUmsatzsteuerausweis';
    xdsKundendatenUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsKundendatenZahlungsbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenZahlungsbedingung.Name := 'xdsKundendatenZahlungsbedingung';
    xdsKundendatenZahlungsbedingung.FieldName := 'Zahlungsbedingung';
    xdsKundendatenTransportbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenTransportbedingung.Name := 'xdsKundendatenTransportbedingung';
    xdsKundendatenTransportbedingung.FieldName := 'Transportbedingung';
    xdsKundendatenTransportbedingung.Size := 100;
    xdsKundendatenKeinNewsletter.SetParentComponent(xdsKundendaten);
    xdsKundendatenKeinNewsletter.Name := 'xdsKundendatenKeinNewsletter';
    xdsKundendatenKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsKundendatenTelefonAlternativ.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonAlternativ.Name := 'xdsKundendatenTelefonAlternativ';
    xdsKundendatenTelefonAlternativ.FieldName := 'TelefonAlternativ';
    xdsKundendatenTelefonAlternativ.Size := 50;
    xdsKundendatenTitel.SetParentComponent(xdsKundendaten);
    xdsKundendatenTitel.Name := 'xdsKundendatenTitel';
    xdsKundendatenTitel.FieldName := 'Titel';
    xdsKundendatenKundenklasseFarbe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundenklasseFarbe.Name := 'xdsKundendatenKundenklasseFarbe';
    xdsKundendatenKundenklasseFarbe.FieldName := 'KundenklasseFarbe';
    xdsKundendatenRechnungEmail.SetParentComponent(xdsKundendaten);
    xdsKundendatenRechnungEmail.Name := 'xdsKundendatenRechnungEmail';
    xdsKundendatenRechnungEmail.FieldName := 'RechnungEmail';
    xdsKundendatenRechnungEmail.Size := 50;
    xdsKundendatenLoginPW.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginPW.Name := 'xdsKundendatenLoginPW';
    xdsKundendatenLoginPW.FieldName := 'LoginPW';
    xdsKundendatenBesteuerungKey.SetParentComponent(xdsKundendaten);
    xdsKundendatenBesteuerungKey.Name := 'xdsKundendatenBesteuerungKey';
    xdsKundendatenBesteuerungKey.FieldName := 'BesteuerungKey';
    xdsKundendatenAuftraegeJahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeJahr.Name := 'xdsKundendatenAuftraegeJahr';
    xdsKundendatenAuftraegeJahr.FieldName := 'AuftraegeJahr';
    xdsKundendatenAuftraegeVorjahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeVorjahr.Name := 'xdsKundendatenAuftraegeVorjahr';
    xdsKundendatenAuftraegeVorjahr.FieldName := 'AuftraegeVorjahr';
    xdsKundendatenLieferadresseID.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferadresseID.Name := 'xdsKundendatenLieferadresseID';
    xdsKundendatenLieferadresseID.FieldName := 'LieferadresseID';
    xdsKundendatenUSTIDgeprueft.SetParentComponent(xdsKundendaten);
    xdsKundendatenUSTIDgeprueft.Name := 'xdsKundendatenUSTIDgeprueft';
    xdsKundendatenUSTIDgeprueft.FieldName := 'USTIDgeprueft';
    xdsKundendatenKontaktverbund.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktverbund.Name := 'xdsKundendatenKontaktverbund';
    xdsKundendatenKontaktverbund.FieldName := 'Kontaktverbund';
    xdsKundendatenKontaktverbund.Size := 25;
    xdsKundendatenHinweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenHinweis.Name := 'xdsKundendatenHinweis';
    xdsKundendatenHinweis.FieldName := 'Hinweis';
    xdsKundendatenHinweis.Size := 255;
    xdsKundendatenLatitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLatitude.Name := 'xdsKundendatenLatitude';
    xdsKundendatenLatitude.FieldName := 'Latitude';
    xdsKundendatenLongitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLongitude.Name := 'xdsKundendatenLongitude';
    xdsKundendatenLongitude.FieldName := 'Longitude';
    xdsKundendatenkmLuftlinie.SetParentComponent(xdsKundendaten);
    xdsKundendatenkmLuftlinie.Name := 'xdsKundendatenkmLuftlinie';
    xdsKundendatenkmLuftlinie.FieldName := 'kmLuftlinie';
    xdsKundendatenGoogleID.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleID.Name := 'xdsKundendatenGoogleID';
    xdsKundendatenGoogleID.FieldName := 'GoogleID';
    xdsKundendatenGoogleID.Size := 50;
    xdsKundendatenGoogleUpdatedUTC.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleUpdatedUTC.Name := 'xdsKundendatenGoogleUpdatedUTC';
    xdsKundendatenGoogleUpdatedUTC.FieldName := 'GoogleUpdatedUTC';
    xdsKundendatenBundesland.SetParentComponent(xdsKundendaten);
    xdsKundendatenBundesland.Name := 'xdsKundendatenBundesland';
    xdsKundendatenBundesland.FieldName := 'Bundesland';
    xdsKundendatenBundesland.Size := 50;
    xdsKundendatenRegion.SetParentComponent(xdsKundendaten);
    xdsKundendatenRegion.Name := 'xdsKundendatenRegion';
    xdsKundendatenRegion.FieldName := 'Region';
    xdsKundendatenRegion.Size := 50;
    xdsKundendatenMandatsreferenz.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenz.Name := 'xdsKundendatenMandatsreferenz';
    xdsKundendatenMandatsreferenz.FieldName := 'Mandatsreferenz';
    xdsKundendatenMandatsreferenz.Size := 34;
    xdsKundendatenMandatsreferenzVom.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenzVom.Name := 'xdsKundendatenMandatsreferenzVom';
    xdsKundendatenMandatsreferenzVom.FieldName := 'MandatsreferenzVom';
    xdsKundendatenLastschriftArt.SetParentComponent(xdsKundendaten);
    xdsKundendatenLastschriftArt.Name := 'xdsKundendatenLastschriftArt';
    xdsKundendatenLastschriftArt.FieldName := 'LastschriftArt';
    xdsKundendatenLastschriftArt.Size := 2;
    xdsKundendatenMahnsperre.SetParentComponent(xdsKundendaten);
    xdsKundendatenMahnsperre.Name := 'xdsKundendatenMahnsperre';
    xdsKundendatenMahnsperre.FieldName := 'Mahnsperre';
    xdsKundendatenSuchbegriff.SetParentComponent(xdsKundendaten);
    xdsKundendatenSuchbegriff.Name := 'xdsKundendatenSuchbegriff';
    xdsKundendatenSuchbegriff.FieldName := 'Suchbegriff';
    xdsKundendatenSuchbegriff.Size := 25;
    xdsKundendatenLieferanschriftDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschriftDaten.Name := 'xdsKundendatenLieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.FieldName := 'LieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.Size := 255;
    xdsKundendatenExportKasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenExportKasse.Name := 'xdsKundendatenExportKasse';
    xdsKundendatenExportKasse.FieldName := 'ExportKasse';
    xdsKundendatenLoeschvormerkungDatum.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungDatum.Name := 'xdsKundendatenLoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungDatum.FieldName := 'LoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungGrund.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungGrund.Name := 'xdsKundendatenLoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.FieldName := 'LoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.Size := 250;
    xdsKundendatenPseudonymisiert.SetParentComponent(xdsKundendaten);
    xdsKundendatenPseudonymisiert.Name := 'xdsKundendatenPseudonymisiert';
    xdsKundendatenPseudonymisiert.FieldName := 'Pseudonymisiert';
    xdsKundendatenPseudonymisiert.Size := 255;
    xdsKundendatenLoginAktiv.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginAktiv.Name := 'xdsKundendatenLoginAktiv';
    xdsKundendatenLoginAktiv.FieldName := 'LoginAktiv';
    xdsKundendatenSonstigeDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenSonstigeDaten.Name := 'xdsKundendatenSonstigeDaten';
    xdsKundendatenSonstigeDaten.FieldName := 'SonstigeDaten';
    xdsKundendatenSonstigeDaten.Size := 255;
    xdsProtokoll.SetParentComponent(Self);
    xdsProtokoll.Name := 'xdsProtokoll';
    xdsProtokoll.AfterOpen := xdsProtokollAfterOpen;
    xdsProtokoll.EntitySetName := 'KundenportalProtokoll';
    xdsProtokoll.Connection := DM2.XDataWebConnection1;
    xdsProtokoll.QueryTop := 1;
    xdsProtokoll.Left := 41;
    xdsProtokoll.Top := 192;
    xdsProtokollID.SetParentComponent(xdsProtokoll);
    xdsProtokollID.Name := 'xdsProtokollID';
    xdsProtokollID.FieldName := 'ID';
    xdsProtokollDatum.SetParentComponent(xdsProtokoll);
    xdsProtokollDatum.Name := 'xdsProtokollDatum';
    xdsProtokollDatum.FieldName := 'Datum';
    xdsProtokollKundennummer.SetParentComponent(xdsProtokoll);
    xdsProtokollKundennummer.Name := 'xdsProtokollKundennummer';
    xdsProtokollKundennummer.FieldName := 'Kundennummer';
    xdsProtokollKundennummer.Size := 13;
    xdsProtokollNotiz.SetParentComponent(xdsProtokoll);
    xdsProtokollNotiz.Name := 'xdsProtokollNotiz';
    xdsProtokollNotiz.FieldName := 'Notiz';
    xdsProtokollNotiz.Size := 250;
    xdsProtokollPruefungErforderlich.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErforderlich.Name := 'xdsProtokollPruefungErforderlich';
    xdsProtokollPruefungErforderlich.FieldName := 'PruefungErforderlich';
    xdsProtokollPruefungErledigt.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigt.Name := 'xdsProtokollPruefungErledigt';
    xdsProtokollPruefungErledigt.FieldName := 'PruefungErledigt';
    xdsProtokollPruefungErledigtDurch.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigtDurch.Name := 'xdsProtokollPruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.FieldName := 'PruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.Size := 50;
    xdsProtokollBemerkung.SetParentComponent(xdsProtokoll);
    xdsProtokollBemerkung.Name := 'xdsProtokollBemerkung';
    xdsProtokollBemerkung.FieldName := 'Bemerkung';
    xdsProtokollBemerkung.Size := 255;
  finally
    TC.AfterLoadDFMValues;
    xdsLaender.AfterLoadDFMValues;
    xdsLaenderLaenderkuerzel.AfterLoadDFMValues;
    xdsLaenderLand.AfterLoadDFMValues;
    xdsLaenderEULand.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenGruppeKunden.AfterLoadDFMValues;
    xdsKundendatenGruppeLieferanten.AfterLoadDFMValues;
    xdsKundendatenGruppeSonstige.AfterLoadDFMValues;
    xdsKundendatenGruppeNichtkunden.AfterLoadDFMValues;
    xdsKundendatenKontaktgruppe.AfterLoadDFMValues;
    xdsKundendatenNachname.AfterLoadDFMValues;
    xdsKundendatenVorname.AfterLoadDFMValues;
    xdsKundendatenAdresszeile2.AfterLoadDFMValues;
    xdsKundendatenAdresszeile3.AfterLoadDFMValues;
    xdsKundendatenStrasse.AfterLoadDFMValues;
    xdsKundendatenPostleitzahl.AfterLoadDFMValues;
    xdsKundendatenOrt.AfterLoadDFMValues;
    xdsKundendatenLaenderkuerzel.AfterLoadDFMValues;
    xdsKundendatenLand.AfterLoadDFMValues;
    xdsKundendatenLaenderkennzeichen.AfterLoadDFMValues;
    xdsKundendatenAdressanrede.AfterLoadDFMValues;
    xdsKundendatenBriefanrede1.AfterLoadDFMValues;
    xdsKundendatenAdresseBild.AfterLoadDFMValues;
    xdsKundendatenLieferanschrift.AfterLoadDFMValues;
    xdsKundendatenTelefonNummer.AfterLoadDFMValues;
    xdsKundendatenTelefaxNummer.AfterLoadDFMValues;
    xdsKundendatenMobilTelefon.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenInternet.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerID.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsKundendatenZahlungsbedingung.AfterLoadDFMValues;
    xdsKundendatenTransportbedingung.AfterLoadDFMValues;
    xdsKundendatenKeinNewsletter.AfterLoadDFMValues;
    xdsKundendatenTelefonAlternativ.AfterLoadDFMValues;
    xdsKundendatenTitel.AfterLoadDFMValues;
    xdsKundendatenKundenklasseFarbe.AfterLoadDFMValues;
    xdsKundendatenRechnungEmail.AfterLoadDFMValues;
    xdsKundendatenLoginPW.AfterLoadDFMValues;
    xdsKundendatenBesteuerungKey.AfterLoadDFMValues;
    xdsKundendatenAuftraegeJahr.AfterLoadDFMValues;
    xdsKundendatenAuftraegeVorjahr.AfterLoadDFMValues;
    xdsKundendatenLieferadresseID.AfterLoadDFMValues;
    xdsKundendatenUSTIDgeprueft.AfterLoadDFMValues;
    xdsKundendatenKontaktverbund.AfterLoadDFMValues;
    xdsKundendatenHinweis.AfterLoadDFMValues;
    xdsKundendatenLatitude.AfterLoadDFMValues;
    xdsKundendatenLongitude.AfterLoadDFMValues;
    xdsKundendatenkmLuftlinie.AfterLoadDFMValues;
    xdsKundendatenGoogleID.AfterLoadDFMValues;
    xdsKundendatenGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsKundendatenBundesland.AfterLoadDFMValues;
    xdsKundendatenRegion.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenz.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenzVom.AfterLoadDFMValues;
    xdsKundendatenLastschriftArt.AfterLoadDFMValues;
    xdsKundendatenMahnsperre.AfterLoadDFMValues;
    xdsKundendatenSuchbegriff.AfterLoadDFMValues;
    xdsKundendatenLieferanschriftDaten.AfterLoadDFMValues;
    xdsKundendatenExportKasse.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungDatum.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungGrund.AfterLoadDFMValues;
    xdsKundendatenPseudonymisiert.AfterLoadDFMValues;
    xdsKundendatenLoginAktiv.AfterLoadDFMValues;
    xdsKundendatenSonstigeDaten.AfterLoadDFMValues;
    xdsProtokoll.AfterLoadDFMValues;
    xdsProtokollID.AfterLoadDFMValues;
    xdsProtokollDatum.AfterLoadDFMValues;
    xdsProtokollKundennummer.AfterLoadDFMValues;
    xdsProtokollNotiz.AfterLoadDFMValues;
    xdsProtokollPruefungErforderlich.AfterLoadDFMValues;
    xdsProtokollPruefungErledigt.AfterLoadDFMValues;
    xdsProtokollPruefungErledigtDurch.AfterLoadDFMValues;
    xdsProtokollBemerkung.AfterLoadDFMValues;
  end;
end;

end.